import request from "~/utils/http";

const authApi = {
	token : async (username, password) => {
		const url = 'auth/login';
		return await request.post(url, {username, password});
	},
	register : async (params) => {
		const url = 'auth/register';
		return await request.post(url, params);
	},
	current : async () => {
		const url = 'auth/current';
		return await request.get(url);
	},
	refresh : async (params) => {
		const url = 'auth/refresh-token';
		return await request.post(url, params);
	},
	update : async (params) => {
		const url = 'auth/update';
		return await request.post(url, params);
	},
	password : async (params) => {
		const url = 'auth/password';
		return await request.post(url, params);
	},
};

export default authApi;